var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article-list-page-template',{staticClass:"px-lg-15",attrs:{"title":_vm.pageTitle,"loading":_vm.loading,"no-data-text":"Nenhum boletim disponível."},scopedSlots:_vm._u([{key:"items",fn:function(){return _vm._l((_vm.items),function(ref,i){
var img = ref.img;
var title = ref.title;
var scheduled = ref.scheduled;
var to = ref.to;
return _c('covid-card',{key:i,staticClass:"mb-3 white--text",attrs:{"img":img,"title":title,"date":scheduled,"to":to,"large":""}})})},proxy:true},{key:"side",fn:function(){return [_c('communications-widget')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }